<template>
  <form-section
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    no-validity
  >
    <form-section-question>Almost there... a few final things before we generate your quotes.</form-section-question>

    <form-section-label>Terms & Conditions</form-section-label>

    <div
      class="terms-and-conditions ql-editor"
      data-test="terms_and_conditions"
      @click.prevent.stop="processTermsAndConditionsLink"
      v-html="config.partnerTermsAndConditions"
    />
  </form-section>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-terms-and-conditions',
  extends: QuestionBase,
  inject: [
    'config',
  ],
  methods: {
    processTermsAndConditionsLink ({ target }) {
      if (target && target.tagName.toLowerCase() === 'a') {
        window.open(target.href, '_blank').focus();
      }
    },
  },
};
</script>
